module.exports = __webpack_public_path__ + "static/media/muscle_front_3.a8a6bfad.png";